import createReducer from '../../helpers/CreateReducer';
import { ApiConstants } from '../../constants/actions';

interface SignUpState {
  isError: boolean;
  active: boolean;
}

export const getInitialState = (): SignUpState => ({
  isError: false,
  active: false
});

export default createReducer(getInitialState, {
  [`${ApiConstants.SIGN_UP}_REQUEST`]: (): Partial<SignUpState> => ({
    active: true,
    isError: false
  }),
  [`${ApiConstants.SIGN_UP}_FAILURE`]: (): Partial<SignUpState> => ({
    isError: true
  })
});
